import React, {useState} from 'react';
import ValidationError from "~/Components/Forms/ValidationError";
import {Form} from "react-bootstrap";
import placeholder from "~/assets/placeholder-image.svg";
import AdminImageUploader from "~/Admin/AdminImageUploader/AdminImageUploader";

const AdminLangForm = ({values, errors, onChange}) => {

    const defaultFields = {
        code: '',
        name: '',
        display_order: 0,
        rtl: false,
        active: false,
    };

    const form = {...defaultFields, ...values};

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    const handleCheckboxChange = (e) => {

        const name = e.target.name;
        const value = e.target.checked;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <div>
            <div className="form-group">
                <label>Code</label>
                <input
                    onChange={handleChange}
                    value={form.code}
                    name="code"
                    type="text"
                    className="form-control"/>

                <ValidationError errors={errors} name="code"/>
            </div>
            <div className="form-group">
                <label>Name</label>
                <input
                    onChange={handleChange}
                    value={form.name}
                    name="name"
                    type="text"
                    className="form-control"/>

                <ValidationError errors={errors} name="name"/>
            </div>

            <div className="form-group">
                <label>Display Order</label>
                <input
                    onChange={handleChange}
                    value={form.display_order}
                    name="display_order"
                    type="text"
                    className="form-control"/>

                <ValidationError errors={errors} name="display_order"/>
            </div>

            <div className="form-group">

                <Form.Check
                    inline
                    type="checkbox"
                    name="rtl"
                    onChange={handleCheckboxChange}
                    label="Right to left ?"
                    checked={form.rtl}
                />

                <ValidationError errors={errors} name="rtl"/>
            </div>

            <div className="form-group">

                <Form.Check
                    inline
                    type="checkbox"
                    name="active"
                    onChange={handleCheckboxChange}
                    label="Active ?"
                    checked={form.active}
                />

                <ValidationError errors={errors} name="active"/>
            </div>
        </div>
    );
}


export default AdminLangForm;
